import React, { useState, useRef } from 'react';
import { toast } from 'react-toastify';
import { sendPasswordResetEmail } from 'firebase/auth';
import { firebaseAuthFunc } from '../../config/firebaseAuth';

export default function ForgotPWComponent() {
  const [emailField, setemailField] = useState('');
  const [loading, setloading] = useState(false);
  const toastId = useRef(null);

  const submitForgotPass = async (e) => {
    e.preventDefault();
    setloading(true);
    await sendPasswordResetEmail(firebaseAuthFunc, emailField)
      .then(async (res) => {
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.success(
            'Reset password link has been sent to your email address.',
            {
              position: 'bottom-left',
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            },
          );
        }
        setloading(false);
      })
      .catch((error) => {
        const { message, code } = error;
        let errorMessage = '';
        switch (code) {
          case 'auth/invalid-email':
          case 'auth/user-not-found': {
            errorMessage =
              'This email address is either not valid or not supported.';
            break;
          }
          case 'auth/missing-email': {
            errorMessage = 'Missing Email. Please enter a valid email address.';
            break;
          }
          default: {
            errorMessage = message;
            break;
          }
        }
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.error(errorMessage, {
            position: 'bottom-left',
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
        setloading(false);
      });
  };

  return (
    <>
      <main className="main center_container">
        <div className="container">
          <div className="row row--grid">
            <div className="w-full pt-2">
              <ul className="breadcrumb">
                <li className="breadcrumb__item yellow__back">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb__item--active yellow__back--active">
                  Restore password
                </li>
              </ul>
            </div>
          </div>
          <div className="row row--grid">
            <div className="w-full">
              <div className="sign">
                <div className="sign__content">
                  <form
                    id="forgot-password-form"
                    onSubmit={submitForgotPass}
                    className="sign__form"
                  >
                    <span className="sign__logo">MusicArt</span>

                    <div className="sign__group">
                      <input
                        type="email"
                        className="sign__input"
                        placeholder="Email address"
                        required
                        value={emailField}
                        onChange={(e) => {
                          setemailField(e.target.value);
                        }}
                      />
                    </div>

                    <button
                      type="submit"
                      className={
                        loading ? `sign__btn disable_btn` : `sign__btn`
                      }
                      disabled={loading ? true : false}
                    >
                      {loading ? (
                        <div className="flex justify-center	w-full my-6 mx-6 follow-btn-loader">
                          <i className="fas fa-circle-notch animate-spin text-blueGray-800 mx-auto"></i>
                        </div>
                      ) : (
                        <>Send</>
                      )}
                    </button>

                    <span className="sign__text">
                      We will send a password reset link to your Email.
                    </span>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
